var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.60352H7C4 2.60352 2 4.60352 2 7.60352V13.6035C2 16.6035 4 18.6035 7 18.6035V20.7335C7 21.5335 7.89 22.0135 8.55 21.5635L13 18.6035H17C20 18.6035 22 16.6035 22 13.6035V7.60352C22 4.60352 20 2.60352 17 2.60352ZM12 14.7735C11.58 14.7735 11.25 14.4335 11.25 14.0235C11.25 13.6135 11.58 13.2735 12 13.2735C12.42 13.2735 12.75 13.6135 12.75 14.0235C12.75 14.4335 12.42 14.7735 12 14.7735ZM13.26 10.6235C12.87 10.8835 12.75 11.0535 12.75 11.3335V11.5435C12.75 11.9535 12.41 12.2935 12 12.2935C11.59 12.2935 11.25 11.9535 11.25 11.5435V11.3335C11.25 10.1735 12.1 9.60352 12.42 9.38352C12.79 9.13352 12.91 8.96352 12.91 8.70352C12.91 8.20352 12.5 7.79352 12 7.79352C11.5 7.79352 11.09 8.20352 11.09 8.70352C11.09 9.11351 10.75 9.45352 10.34 9.45352C9.93 9.45352 9.59 9.11351 9.59 8.70352C9.59 7.37352 10.67 6.29352 12 6.29352C13.33 6.29352 14.41 7.37352 14.41 8.70352C14.41 9.84351 13.57 10.4135 13.26 10.6235Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.54160bc7f5251b16302c85bb22e19ec7.svg";
export { ForwardRef as ReactComponent };